/*
Sohel 01/02/2023 2789725780 Basic Info API Integration
Sohel 01/03/2023 2789725780 fixed prepopulate Issue
Sohel 01/04/2023 2789725780 Basic Info Changes
Sohel 01/05/2023 2789725780 added Validation Group Code
dilip 01/10/2023 2789725780 Added unsaved popup.
sai krishna 01/12/2023 2789725780 fixed Record Identifier Position issue.
Sohel 01/12/2023 2789725780 isDraft Changes
manikanta 01/12/2023 2789725780,3075154998 fixed delete popup message
Sohel 01/16/2023 2789725780 fixed is Draft issue
Sohel 01/20/2023 2698964415 changed dropdown values
Sohel 01/20/2023 2789725780 Added LastStep in payload
Sohel 01/22/2023 2789725780 basicInfo FixedLength Changes
Sohel 01/24/2023 2789725780 Added category Fields
Sohel 01/25/2023 2698964415 payload and validation changes
Ashraf 01/27/2023 2698964415 added new fields category and audit
Sohel 01/30/2023 2698964415 Fixed number Fields validation issue
Sohel 01/31/2023 2698964415 payload changes
Sohel 01/02/2023 2698964415 fixed page break issue
Sohel 01/02/2023 2698964415 fixed code uppercase issue
Sohel 01/02/2023 2698964415 fixed validation issue
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Rohini 02/09/2023 2701335619 added classnames and enhancements in the text feilds
Sohel 01/08/2023 2698964415 implemented Usage Functionality
Dilip 02/09/2023 2698964415 added creted for  and payload changes
Suresh Peddavoora  02/13/2023 2698964415 Fixed Textfields Variant
Rohini 02/28/2023 2698964415 added classname for screen enhancements.
Ravi 02/20/2023 2698964415 fixed validation issue in code
Rohini 03/01/2023 2698964415 worked on the code enhancements.
sohel 03/06/2023 2698964415 Added validation message for existing value
Prakash 03/17/2023 2698964415 fixed ui bugs in responsive.
Sohel 04/26/2023 2692790263 Fixed Created FOr Validation Issue
Akhila 06/08/2023 2692790263 title label placeholder name change
Akhila 06/12/2023 2692790263 added role access
Ravi 06/23/2023 2692790263 fixed submit issue
Suresh Peddavoora 07/03/2023 2692790263 Fixed label overlapping issue
*/

import React, {useContext, useEffect, useRef, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {TextField, FormHelperText, Button, MenuItem} from '@material-ui/core';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {
  postBasicInfo,
  resetBasicInfo,
  fetchBasicInfoData,
  setRecordGroupRedux,
  setFixedLengthRedux,
  fetchAllRecordGroupCode,
  setCategoryRecordGroupRedux,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
// import {upperCaseCode} from '../../../../../components/UpperCaseCode';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {getAllReportCreatedForData} from '../../../../../redux/reducers/ReportMaster';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
import {createForOptions} from '../../../../../util/CreatedByForOptions';
import { currsorCodeIssue } from '../../../../../components/UpperCaseCode';

const importManagerType = [
  {value: 'New Account Import'},
  // { value: "New Payment Import" },
  {value: 'Data Update'},
  {value: 'Customer Query'},
  {value: 'Exception'},
  {value: 'Header'},
  {value: 'Footer'},
];
const exportManagerType = [{value: 'Data Export'}, {value: 'Header'}, {value: 'Footer'}];

const fixedLengthOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const IMRGBasicInfo = ({
  activeStep,
  handleNext,
  exportManagerRecordGroup,
  showAlertRef,
  handleDirty,
  exportRecordGroupAccess,
  importRecordGroupAccess,
  editExisting,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [codePopover, setCodePopover] = useState(false);
  const [recordGroupCodesData, setRecordGroupCodesData] = useState();
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {reportCreatedForData} = useSelector(({reportMaster}) => reportMaster);
  const saveRef = useRef();
  const {
    isLoading,
    successMsg,
    errorMsg,
    addBasicInfoStatus,
    // groupCode,
    dmRecordGroupId,
    isDraftRecordGroup,
    basicInfoData,
    allRecordGroupCode,
  } = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const type = exportManagerRecordGroup ? 'Export' : 'Import';
  const codeRef = useRef();
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option || item.key === option || item.categoryCode === option) {
          label = item;
        }
      });
    return label;
  };
  const getObjectData = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.value === option ||
          item.key === option ||
          item.userName === option || item.userLoginName === option ||
          item.categoryCode === option
        ) {
          label = item;
        }
      });
    return label;
  };
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  const checkRecordCodeExist = (value) => {
    if (allRecordGroupCode && allRecordGroupCode?.length > 0 && value) {
      const ar = [];
      allRecordGroupCode.filter((i) => {
        if (
          i?.groupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkRecordCodeAlreadyExist = (value) => {
    if (allRecordGroupCode && allRecordGroupCode?.length > 0 && value) {
      const ar = [];
      allRecordGroupCode.filter((i) => {
        if (
          i?.groupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];
  const promptOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const category = basicInfoData?.category ?
    getObject(basicInfoData?.category, categoryData) :
    {categoryCode: 'CO', categoryName: 'Core'};
  const recordType = basicInfoData?.groupType ?
    getObject(basicInfoData?.groupType, [...importManagerType, ...exportManagerType]) :
    '';
  const fixedLength = basicInfoData?.fixedLength ?
    getObject(basicInfoData?.fixedLength, fixedLengthOptions) :
    {key: 'N', value: 'No'};
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialVal = {
    code: basicInfoData?.groupCode ? basicInfoData?.groupCode : '',
    description: basicInfoData?.groupDescription ? basicInfoData?.groupDescription : '',
    imrType: recordType,
    fixedLength: fixedLength,
    recordIdentifier: Number(basicInfoData?.startPosition),
    recordIdentifierLength: Number(basicInfoData?.identifierLength),
    category: category,
    includeAudit: basicInfoData?.includeAudit ?
      getObject(basicInfoData?.includeAudit, promptOptions) :
      {key: 'N', value: 'No'},
    createdFor: basicInfoData?.createdFor ?
      getObjectData(basicInfoData?.createdFor, reportCreatedForData) :
      {userLoginName: user?.userName},
  };

  useEffect(() => {
    if ('groupType' in basicInfoData) {
      dispatch(setRecordGroupRedux({property: 'recordType', value: recordType}));
    }
  }, [basicInfoData?.groupType]);
  useEffect(() => {
    if ('fixedLength' in basicInfoData) {
      dispatch(setFixedLengthRedux({property: 'fixedLength', value: fixedLength?.key}));
    }
  }, [basicInfoData?.fixedLength, fixedLength]);
  const validationSchema = Yup.object().shape({
    code: basicInfoData?.groupCode ?
      null :
      Yup.string()
        .required(`${type} Record Group Name is required`)
        .test(
          'code',
              `${type} Record Group Name already exist`,
              (value) => !checkRecordCodeExist(value),
        )
        .test(
          'code',
              `${type} Record Group Name has already been used in the past`,
              (value) => !checkRecordCodeAlreadyExist(value),
        ),
    description: Yup.string()
      .test('description', `${type} Record Group Description is required`, (value) => {
        return value?.replaceAll(' ', '');
      })
      .max(100, `${type} Record Group Description cannot exceed 100 characters`)
      .required(`${type} Record Group Description is required`),
    imrType: Yup.mixed().test('imrType', `${type} Record Group Type is required`, (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    fixedLength: Yup.mixed().test('fixedLength', 'Fixed Length is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    category: Yup.object().required('Category is required').nullable(),
    includeAudit: exportManagerRecordGroup && Yup.mixed().required('Include Audit is required'),
    recordIdentifier: Yup.mixed().test(
      'recordIdentifier',
      'Record Identifier Position is required',
      (value) => {
        if (isNaN(value)) {
          return false;
        } else {
          return true;
        }
      },
    ),
    recordIdentifierLength: Yup.mixed().test(
      'recordIdentifierLength',
      'Record Identifier Length is required',
      (value, ctx) => {
        if (isNaN(value) && ctx.parent.fixedLength?.key === 'Y') {
          return false;
        } else {
          return true;
        }
      },
    ),
  });
  const getRecordGroupCodesData = () => {
    if (allRecordGroupCode && allRecordGroupCode?.length > 0) {
      return allRecordGroupCode?.filter(
        (i) => String(i?.groupCode?.toUpperCase())?.startsWith(recordGroupCodesData.toUpperCase()) && i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        if (successMsg && !saveRef.current && addBasicInfoStatus === 200) {
          handleNext();
        }
        dispatch(resetBasicInfo());
      }, 1500);
    }
  }, [errorMsg, successMsg]);

  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      groupCode: values?.code ? values?.code : '',
      groupDescription: values?.description ? values?.description : '',
      groupType: values?.imrType?.value ? values?.imrType?.value : '',
      dmRecordGroupId: basicInfoData?.dmRecordGroupId ? basicInfoData?.dmRecordGroupId : 0,
      fixedLength: values?.fixedLength?.key ? values?.fixedLength?.key : '',
      startPosition: Number(values?.recordIdentifier),
      identifierLength: Number(values?.recordIdentifierLength),
      isDraft: isDraftRecordGroup ? isDraftRecordGroup : 'Y',
      tabType: exportManagerRecordGroup ? 'Export' : 'Import',
      lastStep: saveRef?.current ?
        basicInfoData?.lastStep :
        isDraftRecordGroup === 'N' ?
          basicInfoData?.lastStep :
          1,
      category: values?.category?.categoryCode ? values?.category?.categoryCode : '',
      includeAudit: values?.includeAudit?.key ? values?.includeAudit?.key : '',
      createdFor: values?.createdFor?.userLoginName ? values?.createdFor?.userLoginName : '',
    };
    dispatch(postBasicInfo(payload));
  };
  useEffect(() => {
    if (dmRecordGroupId) {
      dispatch(fetchBasicInfoData(dmRecordGroupId));
    }
  }, [dmRecordGroupId]);
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
  }, []);
  useEffect(() => {
    if ('category' in basicInfoData) {
      dispatch(setCategoryRecordGroupRedux({property: 'categoryRecordGroup', value: category}));
    }
  }, [basicInfoData?.category]);
  useEffect(() => {
    dispatch(fetchAllRecordGroupCode(type));
  }, []);
  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields mt-2">
                <div className={`${touched.code && errors?.code?.length > 20 ? "mb-5" : " "} col-sm-6 col-md-4 col-xl-3 form-group`}>
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${type} Record Group Name`}
                    label={`${type} Record Group Name`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    inputProps={{maxLength: 25}}
                    disabled={basicInfoData?.groupCode}
                    name="code"
                    required
                    inputRef={codeRef}
                    value={values?.code}
                    onChange={(e) => {
                      const value = currsorCodeIssue(codeRef);
                      setFieldValue('code',value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setRecordGroupCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.code}
                    error={Boolean(touched.code && errors.code)}
                  />
                  <FormHelperText>{touched.code && errors?.code}</FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getRecordGroupCodesData()?.map((data, i) => (
                        <MenuItem fullWidth key={i}>
                          {data?.groupCode}
                        </MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group label-overflow-md">
                  <TextField
                    className={`${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${type} Record Group Description`}
                    label={`${type} Record Group Description`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="description"
                    inputProps={{maxLength: 100}}
                    required
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.description}
                    error={Boolean(touched.description && errors.description)}
                  />
                  <FormHelperText>
                    {touched.description && errors?.description && errors.description}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="imrType"
                    id="imrType"
                    size="small"
                    options={exportManagerRecordGroup ? exportManagerType : importManagerType}
                    autoHighlight
                    value={values.imrType}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    disabled={recordType}
                    onChange={(e, value) => {
                      setFieldValue('imrType', value);
                      dispatch(setRecordGroupRedux({property: 'recordType', value: value}));
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={`${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label={`Record Group Type`}
                          placeholder={`Select Record Group Type`}
                          required
                          error={touched.imrType && errors.imrType}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.imrType && errors.imrType && errors.imrType}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="createdFor"
                    id="createdFor"
                    size="small"
                    value={values.createdFor}
                    options={reportCreatedForData}
                    getOptionLabel={(option) => {
                      return option && option?.userLoginName ? option?.userLoginName : '';
                    }}
                    renderOption={(option) => {
                      return createForOptions(option);
                    }}
                    onChange={(e, value) => {
                      handleChange(e);
                      setFieldValue('createdFor', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Created For"
                          className={`${classes.labelName}`}
                          placeholder="Select Created For"
                        />
                        <FormHelperText variant="outlined">
                          {touched.createdFor && errors.createdFor}
                        </FormHelperText>
                      </div>
                    )}
                  />
                </div>
                <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    id="fixedLength"
                    options={fixedLengthOptions}
                    value={values?.fixedLength}
                    size="small"
                    autoHighlight
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    disabled={basicInfoData?.fixedLength}
                    onChange={(e, data) => {
                      setFieldValue('fixedLength', data);
                      dispatch(setFixedLengthRedux({property: 'fixedLength', value: data?.key}));
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        margin="dense"
                        {...params}
                        className={`${classes.labelName}`}
                        variant="outlined"
                        fullWidth
                        label="Fixed Length"
                        required
                        error={Boolean(touched.fixedLength && errors.fixedLength)}
                        name="fixedLength"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Select Fixed Length"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                  />
                  <FormHelperText style={{color: 'red'}} variant="outlined">
                    {touched.fixedLength && errors.fixedLength}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    id="category"
                    value={values?.category}
                    options={categoryData?.length > 0 ? categoryData : []}
                    size="small"
                    autoHighlight
                    getOptionDisabled={(option) => option?.categoryCode === null}
                    getOptionLabel={(option) => {
                      return option && option?.categoryName ?
                        option?.categoryCode === null ?
                          option?.categoryName :
                          option?.categoryCode + ' - ' + option?.categoryName :
                        '';
                    }}
                    renderInput={(params) => (
                      <GuiTextField
                        {...params}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={`${classes.labelName}`}
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        label="Category"
                        name="category"
                        required
                        placeholder="Select Category"
                        error={Boolean(touched.category && errors.category)}
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'off',
                        }}
                      />
                    )}
                    onChange={(e, data) => {
                      setFieldValue('category', data);
                      dispatch(
                        setCategoryRecordGroupRedux({
                          property: 'categoryRecordGroup',
                          value: data,
                        }),
                      );
                    }}
                  />
                  <FormHelperText variant="outlined">
                    {touched.category && errors.category}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={`${classes.labelName}`}
                    placeholder={`Enter Record Identifier Position`}
                    margin="dense"
                    name="recordIdentifier"
                    value={values.recordIdentifier}
                    variant="outlined"
                    type={'number'}
                    label={`Record Identifier Position`}
                    inputProps={{
                      min: 0,
                    }}
                    error={Boolean(touched.recordIdentifier && errors.recordIdentifier)}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  <FormHelperText variant="outlined">
                    {touched.recordIdentifier && errors.recordIdentifier}
                  </FormHelperText>
                </div>
                {values?.fixedLength?.key === 'Y' && (
                  <div className={`col-sm-6 col-md-3 form-group`}>
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder={`Enter Record Identifier Length`}
                      margin="dense"
                      type="number"
                      name="recordIdentifierLength"
                      value={values.recordIdentifierLength}
                      variant="outlined"
                      label={`Record Identifier Length`}
                      inputProps={{
                        min: 0,
                      }}
                      error={Boolean(
                        touched.recordIdentifierLength && errors.recordIdentifierLength,
                      )}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue('recordIdentifierLength', e.target.value);
                      }}
                      required
                      fullWidth
                    />
                    <FormHelperText variant="outlined">
                      {touched.recordIdentifierLength && errors.recordIdentifierLength}
                    </FormHelperText>
                  </div>
                )}
                {exportManagerRecordGroup && (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="includeAudit"
                      id="includeAudit"
                      size="small"
                      options={promptOptions}
                      required
                      value={values.includeAudit}
                      disabled={Boolean(basicInfoData?.includeAudit)}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('includeAudit', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={`${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            InputLabelProps={{shrink: true}}
                            label="Include Audit"
                            placeholder="Select Include Audit"
                            required
                            error={touched.includeAudit && errors.includeAudit}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.includeAudit && errors.includeAudit && errors.includeAudit}
                    </FormHelperText>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button">
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                  disabled={
                    (editExisting === 'Export Record Group' && !exportRecordGroupAccess?.edit) ||
                    (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit) ||
                    enabledSubmission
                  }
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                    handleSubmit(values);
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 ${classes.buttonRoot}`}
                  disabled={
                    (editExisting === 'Export Record Group' && !exportRecordGroupAccess?.edit) ||
                    (editExisting === 'Import Record Group' && !importRecordGroupAccess?.edit) ||
                    enabledSubmission
                  }
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </>
  );
};

export default IMRGBasicInfo;
